/**
 * Marital-status catalogue — labels match the receiving HR system accept-list.
 * Stored values stay lowercase slugs so existing HRProfile rows keep working.
 */

export const MARITAL_STATUS_OPTIONS = [
  { value: 'single', label: 'SINGLE' },
  { value: 'married', label: 'MARRIED' },
  { value: 'divorced', label: 'DIVORCED' },
  { value: 'widowed', label: 'WIDOWED' },
  { value: 'separated', label: 'SEPARATED' },
  { value: 'partnership', label: 'PARTNERSHIP' },
];

export const MARITAL_STATUS_DISPLAY = {
  single: 'SINGLE',
  married: 'MARRIED',
  divorced: 'DIVORCED',
  widowed: 'WIDOWED',
  separated: 'SEPARATED',
  partnership: 'PARTNERSHIP',
  not_disclosed: 'Not disclosed',
  widow: 'WIDOWED',
  civil_partnership: 'PARTNERSHIP',
};

export const MARITAL_STATUS_DEFAULT = '';

export const MARITAL_STATUS_ACCEPT_LIST = new Set(
  MARITAL_STATUS_OPTIONS.map((o) => o.value)
);

function maritalStatusKey(value) {
  if (!value || typeof value !== 'string') return '';
  return value.trim().toLowerCase().replace(/[\s-]+/g, '_');
}

export function isAcceptListMaritalStatus(value) {
  return MARITAL_STATUS_ACCEPT_LIST.has(maritalStatusKey(value));
}

/** Blank or legacy not_disclosed — not a valid required write. */
export function isIncompleteMaritalStatus(value) {
  const key = maritalStatusKey(value);
  return !key || key === 'not_disclosed';
}

/** Label for a stored slug. Empty string when the value is not marital status. */
export function getMaritalStatusLabel(value) {
  const key = maritalStatusKey(value);
  return MARITAL_STATUS_DISPLAY[key] || '';
}

/**
 * Dropdown options for HR / employee forms.
 * Legacy ``not_disclosed`` is offered only when that is the current stored value
 * so existing profiles do not snap to a blank select.
 */
export function maritalStatusSelectOptions({
  placeholderLabel = 'Select',
  currentValue,
} = {}) {
  const options = [
    { value: '', label: placeholderLabel },
    ...MARITAL_STATUS_OPTIONS,
  ];
  if (maritalStatusKey(currentValue) === 'not_disclosed') {
    options.push({
      value: 'not_disclosed',
      label: MARITAL_STATUS_DISPLAY.not_disclosed,
    });
  }
  return options;
}
